import { CirromLoadingLogo } from "../utils/CirromLoadingLogo";

/**
 * An overlay with the cirrom logo for when data loading is in progress
 */
export function CirromGridOverlay() {
  return <CirromLoadingLogo />;
}
